import { render, staticRenderFns } from "./TagAssignRemoveModal.vue?vue&type=template&id=d58ed88a&scoped=true"
import script from "./TagAssignRemoveModal.vue?vue&type=script&lang=js"
export * from "./TagAssignRemoveModal.vue?vue&type=script&lang=js"
import style0 from "./TagAssignRemoveModal.vue?vue&type=style&index=0&id=d58ed88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58ed88a",
  null
  
)

export default component.exports